var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.026,
    height: 18.026,
    viewBox: "0 0 18.026 18.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37756",
    "data-name": "Group 37756",
    transform: "translate(4.336 5.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37755",
    "data-name": "Group 37755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77933",
    "data-name": "Path 77933",
    d: "M132.336,165.592a.731.731,0,0,0-1.033-.027l-4.665,4.425-2.225-2.285a.731.731,0,0,0-1.047,1.02l2.728,2.8a.731.731,0,0,0,1.027.02l5.189-4.921A.731.731,0,0,0,132.336,165.592Z",
    transform: "translate(-123.158 -165.364)",
    fill: "#5f8b16"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37758",
    "data-name": "Group 37758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37757",
    "data-name": "Group 37757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77934",
    "data-name": "Path 77934",
    d: "M9.013,0a9.013,9.013,0,1,0,9.013,9.013A9.023,9.023,0,0,0,9.013,0Zm0,16.565a7.552,7.552,0,1,1,7.552-7.552A7.56,7.56,0,0,1,9.013,16.565Z",
    fill: "#5f8b16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick1);
export default __webpack_public_path__ + "static/media/tick (1).a0ad266b929f66239f8aad6f4a7feb3f.svg";
export { ForwardRef as ReactComponent };